/**
 * Package nav for the data-centers hub.
 * Chapters live in the slide deck — nav is title + motion + Verge.
 */
export const packageNav: {
  title: string;
  titleHref: string | null;
  homeHref: string;
  homeLabel: string;
} = {
  title: "The Center Will Not Hold",
  /** Hub is the package home — title is current, not a link. */
  titleHref: null,
  homeHref: "/",
  homeLabel: "The Verge",
};
